// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Button_Layout__XJLbU","Button":"Button_Button__2LL8j","Success":"Button_Success__3NfPG","Failed":"Button_Failed__2xeix"};